import { useState } from "react";
import { IChat, IGetChangeRequest } from "@/Washouts/types/PayrollClosing/queries";
import { Grid, Box } from "@mui/material";
import ChatMessages from "./chatMessages";
import ChatInput from "./chatInput";
import { IInput } from "@/Common/api/types/ChangeRequests";

type TChatBodyProps = {
	selectedRowId: string | null;
	data?: IChat[];
	disableAllActions: boolean;
	hideOpenWashout: boolean;
	hideEscalateAction: boolean;
	disableStatusAction: boolean;
	userId: string;
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	position: string;
	statusActionTooltipText?: string;
	canEditWashout: boolean;
	pending: { isPending: boolean; mutationAction: string };
	selectedRow: IGetChangeRequest | null;
	handleUpdate: (input: IInput, action: string, files?: File[]) => void;
};

const ChatBody = (props: TChatBodyProps) => {
	const {
		selectedRowId,
		data,
		disableAllActions,
		hideOpenWashout,
		hideEscalateAction,
		disableStatusAction,
		userId,
		locationId,
		commissionCycleId,
		payPeriodId,
		position,
		handleUpdate,
		pending,
		statusActionTooltipText,
		canEditWashout,
		selectedRow,
	} = props;
	const [alertMessage, setAlertMessage] = useState("");
	const [openPopper, setOpenPopper] = useState(false);
	const [message, setMessage] = useState("");
	const [files, setFiles] = useState<File[]>([]);

	return (
		<Grid container justifyContent="space-between">
			<Grid item>
				<Box className="w-[80vw] h-[530px] max-w-[515px] items-center flex flex-col rounded-[10px]">
					<ChatMessages
						selectedRowId={selectedRowId}
						data={data}
						alertMessage={alertMessage}
						openPopper={openPopper}
						attachedFilesLength={files.length}
						hideOpenWashout={hideOpenWashout}
						userId={userId}
						locationId={locationId}
						commissionCycleId={commissionCycleId}
						payPeriodId={payPeriodId}
						position={position}
						pending={pending}
						canEditWashout={canEditWashout}
						selectedRow={selectedRow}
					/>
					<ChatInput
						alertMessage={alertMessage}
						setAlertMessage={setAlertMessage}
						openPopper={openPopper}
						setOpenPopper={setOpenPopper}
						message={message}
						setMessage={setMessage}
						files={files}
						setFiles={setFiles}
						disableAllActions={disableAllActions}
						hideEscalateAction={hideEscalateAction}
						disableStatusAction={disableStatusAction}
						handleUpdate={handleUpdate}
						pending={pending}
						statusActionTooltipText={statusActionTooltipText}
					/>
				</Box>
			</Grid>
		</Grid>
	);
};

export default ChatBody;
